import { PipelineV2Stage } from '@sunrun/experience-ui-components';
import { PipelineProspect, ProspectsByStage } from 'providers/Pipeline';
import {
  APPT_COMPLETED,
  APPT_SCHEDULED,
  NEW_CUSTOMER,
  OFFER_CREATED,
  OPPTY_CREATED,
  OpptyStageColumn,
  UNKNOWN,
} from 'components/atoms/PipelineConsts';

type PipelineColumnStage = PipelineV2Stage | OpptyStageColumn;

type ProspectsByColumn = {
  [stage in PipelineColumnStage]?: PipelineProspect[] | undefined;
};

const OPPTY_STAGE_PREFIXES: [string, OpptyStageColumn][] = [
  ['1.', OPPTY_CREATED],
  ['2.', APPT_SCHEDULED],
  ['3.', APPT_COMPLETED],
];

const getOpptyStageColumn = (
  prospect: PipelineProspect,
): OpptyStageColumn | undefined => {
  const stageName = (prospect.opportunityStageName ?? '').trim();
  return OPPTY_STAGE_PREFIXES.find(([prefix]) =>
    stageName.startsWith(prefix),
  )?.[1];
};

/**
 * Moves New Customer and Offer Created prospects into columns keyed by their
 * opportunity stage number. Prospects keep their original `pipelineStage`.
 */
const regroupByOpportunityStage = (
  prospectsByStage: ProspectsByStage,
): ProspectsByColumn => {
  const {
    [NEW_CUSTOMER]: newCustomers = [],
    [OFFER_CREATED]: offersCreated = [],
    ...rest
  } = prospectsByStage;

  const regrouped: ProspectsByColumn = {
    ...rest,
    [OPPTY_CREATED]: [],
    [APPT_SCHEDULED]: [],
    [APPT_COMPLETED]: [],
  };
  const unmatched: PipelineProspect[] = [];

  [...newCustomers, ...offersCreated].forEach((prospect) => {
    const column = getOpptyStageColumn(prospect);
    if (column) {
      regrouped[column]?.push(prospect);
    } else {
      unmatched.push(prospect);
    }
  });

  if (unmatched.length > 0) {
    regrouped[UNKNOWN] = [...(rest[UNKNOWN] ?? []), ...unmatched];
  }

  return regrouped;
};

export { regroupByOpportunityStage };
export type { PipelineColumnStage, ProspectsByColumn };
